'use strict';

angular.module('mediacloudApp')
    .controller('RequestResetController', function ($rootScope, $scope, $state, $timeout, Auth) {
        $rootScope.hideHeaderAndFooter = true;
        $rootScope.lmsCSS = false;
        $scope.success = null;
        $scope.error = null;
        $scope.userNotFound = null;
        $scope.resetAccount = {};
        $timeout(function (){angular.element('[ng-model="resetAccount.username"]').focus();});

        $scope.requestReset = function () {

            $scope.error = null;
            $scope.userNotFound = null;

            Auth.resetPasswordInit($scope.resetAccount.username).then(function () {
                $scope.success = 'OK';
            }).catch(function (response) {
                $scope.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    $scope.userNotFound = 'ERROR';
                } else {
                    $scope.error = 'ERROR';
                }
            });
        }

    });
